<div class="modal active exportModal">
  <div class="modal__container">
      <div class="fields">
          <h2>Duplication Check</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="fields__container">
            <div class="fields__container__button" *ngFor="let option of this.optionsToDisplay">
              <div (click)="this.selectOption(option)">
                <label>{{ option }}</label>
              </div>
            </div>
          </div>
      </div>
  </div>
</div>


